import { render, staticRenderFns } from "./WarnUnsyncedPointOnlyRealCardPanel.vue?vue&type=template&id=05b1c6b8&"
import script from "./WarnUnsyncedPointOnlyRealCardPanel.vue?vue&type=script&lang=ts&"
export * from "./WarnUnsyncedPointOnlyRealCardPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports